import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appEnterClick]', // Use as an attribute
})
export class EnterClickDirective {
  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      const focusedElement = document.activeElement as HTMLElement;
      focusedElement?.click();
      event.preventDefault();
    }
  }
}
